import { RefObject, useRef } from 'react'

export { Overlay } from './overlay'
export { OverlayContent } from './overlay-content'
export * from './use-no-body-scroll'

export const useOverlayRef: <T = HTMLElement>() => RefObject<T> = () =>
  useRef(null)
